import {VscCircleLargeFilled} from 'react-icons/vsc';
import {Box, Typography, useTheme, styled, useMediaQuery} from '@mui/material';

import {useState, useEffect} from 'react';
import {CheckIcon, UnCheckIcon, CheckHirist} from '@jobseeker/lotus/icons';
import {Image} from '@jobseeker/lotus/components/Image';
const isAppIimjobs = process.env.NEXT_PUBLIC_APP_NAME === 'iimjobs';

const SelectCircle = styled(Box)(({theme}) => ({
  borderRadius: '100%',
  border: '1.5px solid',
  borderColor: theme.palette.primary.light,
  fontSize: theme.typography.pxToRem(15),
  padding: '1.5px',
  lineHeight: 0,
  opacity: 0.3,
  transition: 'all ease 0.2s',
  color: '#fff',
  '&.selected': {
    color: theme.palette.primary.main,
    opacity: 1,
  },
}));

export default ({selected = [], ...props}: any) => {
  const theme = useTheme();
  const isXXS = useMediaQuery(theme.breakpoints.down('xs'));
  // const [selected, onChange] = useState<any>(
  //   selected ?? []
  // );
  const onChange = (value: any) => {
    if (props.onChange) {
      props.onChange(undefined, value);
    }
  };

  const setOption = (option: any) => {
    const value = option.value ?? option.id;
    const isAlreadySelected = selected?.indexOf(value) > -1;

    if (!isAlreadySelected) {
      if (props.multiSelect) {
        let finalList = [value];

        if (option.selected) {
          finalList = finalList.concat(option.selected);
        }
        onChange(selected?.concat(finalList));
      } else {
        onChange([value]);
      }
    } else {
      const filteredOptions = selected?.filter((_value: any) => {
        if (_value === value) {
          return false;
        }
        if (option?.selected?.length) {
          return option.selected?.indexOf(_value) === -1;
        }
        return true;
      });
      onChange(filteredOptions);
    }
  };
  // useEffect(() => {
  //   if (props.onChange) {
  //     props.onChange(undefined, selected);
  //   }
  // }, [selected]);

  return (
    <Box sx={{p: 0}}>
      {props.options.map((option: any, index: number) => {
        const isSelected = selected?.indexOf(option.value || option.id) > -1;
        return (
          <Box
            key={`${props.name}-${index}`}
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: '10px',
              color: !isSelected
                ? theme.palette.secondary.light
                : theme.palette.primary.main,
              cursor: 'pointer',
              p: theme.spacing(1.2, 2),
            }}
            onClick={() => setOption(option)}
          >
            {!props.multiSelect ? (
              <SelectCircle
                className={isSelected ? 'selected' : ''}
                sx={{borderColor: !isSelected ? '#7e7e7e' : undefined}}
              >
                <VscCircleLargeFilled />
              </SelectCircle>
            ) : (
              <Image
                width={20}
                height={20}
                src={
                  isSelected
                    ? isAppIimjobs
                      ? CheckIcon
                      : CheckHirist
                    : UnCheckIcon
                }
                alt="checkedIcon"
              />
            )}
            <Typography
              variant={'body1'}
              style={{fontSize: isXXS ? '12px' : '14px'}}
            >
              {option.label || option.name}
            </Typography>
          </Box>
        );
      })}
    </Box>
  );
};
